import { useTranslation } from "react-i18next";
import type { WorkspaceEntry } from "../workspace-pages.js";

/** The honest stub for a page that is not built yet (ADR-032): what it will show, and where the capability lives today. */
export function ComingSoonPage({ entry }: { entry: WorkspaceEntry }) {
  const { t } = useTranslation();
  const Icon = entry.icon;
  return (
    <div className="text-muted-foreground flex max-w-prose flex-col gap-3 text-sm">
      <p className="text-foreground flex items-center gap-2 text-base">
        <Icon aria-hidden="true" className="size-5" />
        {t("workspace.comingSoon", { page: t(entry.labelKey) })}
      </p>
      {entry.interim ? (
        <p>
          {t("workspace.today")} {entry.interim}
        </p>
      ) : null}
    </div>
  );
}
